/** Copyright (c) 2018, MOBICOOP. All rights reserved. This project is dual
licensed under AGPL and proprietary licence. This program is free software: you
can redistribute it and/or modify it under the terms of the GNU Affero General
Public License as published by the Free Software Foundation, either version 3 of
the License, or (at your option) any later version. This program is distributed
in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the
implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details. You should have received a
copy of the GNU Affero General Public License along with this program. If not,
see gnu.org/licenses. Licence MOBICOOP described in the file LICENSE
**************************/

<template>
  <div class="slider-container">
    <div class="slider-container-content">
      <swiper
        :modules="modules"
        ref="slider"
        class="slider-style swiper-no-swiping"
        :pagination="{ clickable: false }"
        :options="slideOpts"
        @swiper="onSwiper"
        @slideChange="slideDidChange()"
      >
        <swiper-slide v-for="(slide, index) in slides" :key="index">
          <div style="width: 100%; height: 100%">
            <div class="slide-title">{{ slide.title }}</div>
            <div class="component-content">
              <component
                :ref="slide.component.name"
                :is="slide.component"
              ></component>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="mc-swipper-buttons">
      <ion-button
        :style="{
          visibility: activeIndex !== 0 || this.previous ? 'visible' : 'hidden',
        }"
        class="mc-small-button"
        color="primary"
        fill="outline"
        @click="prev()"
        >{{ $t("Slider.prev") }}</ion-button
      >
      <ion-button
        class="mc-small-button"
        color="success"
        @click="next()"
        :disabled="this.$store.getters.getSliderLoader"
      >
        <span v-if="this.$store.getters.getSliderLoader">
          <ion-icon size="large" class="rotating" name="sync"></ion-icon>
        </span>
        <span v-if="!this.$store.getters.getSliderLoader">{{
          activeIndex >= slides.length - 1
            ? $t("Slider.register")
            : $t("Slider.next")
        }}</span>
      </ion-button>
    </div>
  </div>
</template>

<style lang="scss">
.slider-container {
  height: 100%;
  position: relative;
}

.slider-container-content {
  height: calc(100% - 44px);
  position: relative;
}

.mc-swipper-buttons {
  position: absolute;
  bottom: 0px;
  right: 0px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  background: white;
  z-index: 2;
}

.slide-title {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  color: var(--ion-color-primary);
  opacity: 0.6;
  min-height: 27px;
  margin-bottom: 23px;
}

.slider-style {
  --bullet-background: black;
  --bullet-background-active: var(--ion-color-primary);
  height: 100%;
}

.component-content {
  overflow-x: scroll;
  height: calc(100% - 50px);
  padding-right: 6px;
  width: 100%;
}

.component-content::-webkit-scrollbar {
  display: block;
  width: 3px;
}
.component-content::-webkit-scrollbar-thumb {
  background-color: var(--ion-color-primary);
  border-radius: 5px;
}

.swiper-zoom-container {
  width: 100%;
  height: 100%;
  display: block;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;
}

.swiper-container-horizontal > .swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  top: 25px;
  left: 0;
  width: 100%;
  height: 10px;
}

.swiper-pagination-bullets {
  top: 25px !important;
  left: 0 !important;
  width: 100% !important;
  height: 10px;
}
</style>

<script>
import "swiper/css";
import "@ionic/vue/css/ionic-swiper.css";
import { IonicSlides } from "@ionic/vue";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";

export default {
  name: "slider",
  data() {
    return {
      swiper: null,
      modules: [Pagination, IonicSlides],
      activeIndex: 0,
      slideOpts: {
        initialSlide: 0,
        speed: 400,
        allowTouchMove: false,
        observer: true,
      },
      sliderShow: true,
    };
  },
  async updated() {},
  mounted() {
    // go to slide if there is step param in route
    if (this.$route.query.step) {
      this.$nextTick(() => {
        console.log("slider");
        console.log(this.swiper);
        this.swiper.slideTo(this.$route.query.step, 0);
      });
      this.activeIndex = Number(this.$route.query.step);
    }

    this.$watch(
      () => {
        return this.swiper;
      },
      (val) => {
        this.activeIndex = val.activeIndex;
      }
    );
  },
  // Pass an array of slides {title, component}
  props: {
    slides: Array,
    previous: String,
    backForbidden: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },
    async next() {
      const validation = await this.$refs[
        this.slides[this.activeIndex].component.name
      ][0].validate();
      if (validation) {
        if (this.activeIndex >= this.slides.length - 1) {
          this.$emit("save");
        } else {
          this.activeIndex = this.activeIndex + 1;
          this.$router.replace({ query: { step: this.activeIndex } });
          this.swiper.slideNext();
        }
      }
    },
    prev() {
      if (this.activeIndex == 0 && !!this.previous) {
        this.$router.push(this.previous);
      } else {
        this.activeIndex = this.activeIndex - 1;
        this.$router.replace({ query: { step: this.activeIndex } });
        this.swiper.slidePrev();
      }
    },

    slideDidChange() {
      if (!!this.swiper) {
        if (!!this.slides[this.swiper.activeIndex]) {
          this.$store.commit(
            "slider_change",
            this.slides[this.swiper.activeIndex].component.name
          );
        }
      }
    },
  },
};
</script>
